import React, { useContext, useEffect, useState } from "react";
import { ACCOUNT_TYPE_NORMAL } from "@config/config";
import { AuthContext } from "@context/AuthContext";
import Loader from "@components/Ui/Loader";
import MovieTile from "@components/V3/Movies/MovieTile";
import { fetchWatchlistStatus } from "@utils/watchlistService";

const MoviesComingSoon = () => {
    const { comingSoon, isMoviesLoading, user } = useContext(AuthContext);
    const [watchlistStatus, setWatchlistStatus] = useState(null);
    const [watchlistError, setWatchlistError] = useState(false);
    const isNormal = user?.account_type_id === ACCOUNT_TYPE_NORMAL;

    useEffect(() => {
        let isStale = false;

        if (isNormal && comingSoon.length > 0) {
            setWatchlistError(false);
            const movieIds = comingSoon.map(movie => movie.id);

            fetchWatchlistStatus(movieIds, user, (status) => {
                if (!isStale) {
                    setWatchlistStatus(status ?? {});
                    setWatchlistError(status === null);
                }
            });
        } else if (!isNormal) {
            setWatchlistStatus({});
        }

        return () => {
            isStale = true;
        };
    }, [comingSoon, user, isNormal]);

    if (isMoviesLoading) {
        return <Loader isLoading={isMoviesLoading} />;
    }

    if (comingSoon.length === 0) {
        return (
            <div className="movie-list__content">
                <p className="movie-list__no-movies">
                    There are currently no movies Coming Soon. Please check back again later.
                </p>
            </div>
        );
    }

    if (isNormal && watchlistStatus === null) {
        return <Loader isLoading={true} />;
    }

    return (
        <div className="movie-list__content">
            {watchlistError && (
                <div className="movie-list__warning">
                    <p>Unable to load watchlist status. Watchlist features may not work correctly.</p>
                </div>
            )}
            {comingSoon.map((movie) => (
                <div className="movie-list__item" key={movie.id}>
                    <MovieTile
                        movie={movie}
                        variant="coming-soon"
                        initialInWatchlist={(watchlistStatus || {})[movie.id] || false}
                    />
                </div>
            ))}
        </div>
    );
};

export default MoviesComingSoon;
